import { createSelector } from 'reselect';
import { get } from 'lodash';
import isZocdocBrand from '@zocdoc-frontend-common/utils-react/isZocdocBrand';
import {
    THEME_ROOT_KEY,
    PARAMETERS_KEY,
    ZD_DIRECTORY_ID,
} from '@zocdoc-frontend-common/utils-react/constants';
import { VARIANT_ON } from './constants';
import { AB_ROOT_KEY } from './constants';

const getAbParameters = state => get(state, AB_ROOT_KEY);
const getDirectoryId = state =>
    get(state, `${THEME_ROOT_KEY}.directoryId`, ZD_DIRECTORY_ID);
const getIsCovidVaccineSearch = state =>
    get(state, `${PARAMETERS_KEY}.isCovidVaccineSearch`, false);

/**
 * Helper function to create an ab experiment selector. The created selector always returns a boolean.
 * The selector will check if the passed in experiment has the "on" variant ('on' by default).
 * Non-Zocdoc directories will always return false.
 *
 * Examples:
 *   const showTimesgridTooltip = createAbExperimentSelector(PCE_TIMESGRID_TOOLTIP);
 *   const showSsoIcons = createAbExperimentSelector(PCE_EXPRESS_CHECKOUT, 'ssoIcons');
 *   const showSsoButtons = createAbExperimentSelector(PCE_EXPRESS_CHECKOUT, 'ssoButtons');
 * @param {object} experiment
 */
export const createAbExperimentSelector = (
    experiment,
    onVariant = VARIANT_ON
) =>
    createSelector(
        [getDirectoryId, getIsCovidVaccineSearch, getAbParameters],
        (directoryId, isCovidVaccineSearch, ab) =>
            isZocdocBrand(directoryId) &&
            !isCovidVaccineSearch &&
            get(ab, experiment.experimentId, '').toLowerCase() === onVariant
    );
